<template>
  <div>


    <PrintDocumentNew
        style="display: none"

        v-for="print  in print_selected_datas"
        :factor_master="print.factorMasterItem"
        :factor_items="print.factorDetailItems"
        :factor_result="print.factorResult"
        :contact_data="contact_data_response"
        :address_data="address_data_response"
        :message_data="messages_data_response"
        :user_contacts="print.personContacts"
        :user_addresses="print.personAddresses"
    />
    <div id="print_tajmi_factor_products" style="display: none">
      <CDataTable
          :items="print_selected_datas_products"
          :fields="fields_print_selected_products"
          striped
          border

          :items-per-page="200"
          hover
          pagination
      >
        <template #row="{item,index}">

          <td style="text-align: center">
            <strong>{{ index + 1 }}</strong>

          </td>

        </template>
        <template #name="{item}">
          <td>
            <strong>{{ item.productCode }} {{ item.productName }}</strong>
          </td>
        </template>

        <template #unit="{item}">
          <td>
            <strong>{{ item.value }}</strong>
          </td>
        </template>

        <template #qty="{item}">
          <td style="text-align: right">

            <strong style="text-align: right">{{ Math.abs(item.qty) / item.value }}</strong>
          </td>
        </template>
        <template #productUnitName="{item}">
          <td>
            <strong>{{ item.productUnitName }}</strong>
          </td>
        </template>


      </CDataTable>

    </div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>{{ $t('factorLists') }}</strong>
              </CCol>
              <CCol style="text-align: end;">
                <CButton class="mr-1" style="border: 1px solid gray;" size="sm"
                         v-if="id_checkbox_items.length==0">
                  {{ $t('reOrder') }}
                </CButton>
                <CButton class="mr-1" v-if="id_checkbox_items.length>0" @click="AddReOrder()" size="sm"
                         color="dark">
                  {{ $t('reOrder') }}
                </CButton>
                <CButton class="mr-1 " style="border: 1px solid gray;" v-if="id_checkbox_items.length==0" size="sm"
                >
                  {{ $t('PrintSelected') }}
                </CButton>
                <CButton class="mr-1" v-if="id_checkbox_items.length>0" @click="get_contact()" size="sm"
                         color="dark">
                  {{ $t('PrintSelected') }}
                </CButton>
                <CButton class="mr-1" v-if="id_checkbox_items.length>0 && get_access('all_factor_nesie')" @click="print_selected(true)" size="sm"
                         color="dark">
                  پرینت کالا ها
                </CButton>
              </CCol>

            </CRow>
            <CRow>
              <CCol col="3">
                <date-picker

                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>
              <CCol col="3">
                <CSelect
                    :value.sync="selected_route"
                    :options="route_items"
                    horizontal

                    :label="$t('route')"
                />
              </CCol>

              <CCol col="1">
                <CButton @click="get_all_data" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>

            <CCard v-if="submit_refer!=0">
              <CCardHeader>
                <strong>{{ $t('components.referToUser') }}</strong>
              </CCardHeader>
              <CCardBody>
                <CForm>


                  <CCol sm="6" md="4">
                    <CRow>
                      <CCol sm="12">
                        <treeselect
                            v-model="refer_person"

                            :async="true"
                            :load-options="load_persons"
                            :placeholder="$t('components.searchUser')"
                            :normalizer="normalizer_persons"
                        />

                      </CCol>
                    </CRow>

                  </CCol>

                </CForm>
              </CCardBody>
              <CCardFooter>
                <CButton @click="insert_refer()" type="submit" size="sm" color="primary">
                  <CIcon name="cil-check-circle"/>
                  {{ $t('components.referToUser') }}
                </CButton>

                <CButton @click="submit_refer = 0,id_checkbox_items=[]" type="reset" size="sm"
                         color="danger">
                  <CIcon name="cil-ban"/>
                  {{ $t("buttons.cancel") }}
                </CButton>
              </CCardFooter>
            </CCard>
            <CDataTableFixed
                :items="items_sell_filtered"
                :fields="fields"
                column-filter
                @row-clicked="table_row_clicked"
                height="350px"
                :items-per-page="20"
                hover
                sorter
                :checkbox="true"
                :checkbox_ids.sync="id_checkbox_items"
                checkbox_key="recId"
                border
                striped
                :sorter-value="{column:'recId',asc:false}"

            >
              <template #row="{item,index}">

                <td>
                  <p class="text-center">{{ index + 1 }}</p>

                </td>

              </template>
              <template #docDate="{item}">

                <td>
                  <p v-if="!get_access('hyper_sale')" class="text-center">{{ get_date(item.docDate) }}</p>
                  <p v-else class="text-center">{{ get_date_time(item.createdAt) }}</p>

                </td>

              </template>


              <template #masterCode="{item}">
                <td>
                  <p class="text-center">{{ item.masterCode }}</p>

                </td>

              </template>
              <template #totalPrice="{item}">

                <td>
                  <p v-if="item.totalPrice!=null" class="text-right">{{
                      get_currency(item.totalPrice.replace(/,/g, ""))
                    }}</p>

                </td>


              </template>
              <template #partyName="{item}">

                <td>
                  <p>{{ item.partyName }}</p>

                </td>

              </template>
              <template #partyCode="{item}">
                <td>
                  <p class="text-center">{{ item.partyCode }}</p>
                </td>
              </template>
              <template #payType="{item}">
                <td>
                  <p class="text-center">{{ item.payType }}</p>
                </td>
              </template>
              <template #user="{item}">

                <td>
                  <p>{{ item.createdBy }}</p>

                </td>

              </template>


              <template #operation="{item}">
                <td>

                  <CButton v-if="item.statusId ==0"

                           size="sm"
                           :title="$t('buttons.finalize')"
                           @click="Finalize(item)"
                  >
                    <CIcon name="cil-trash" class="text-danger"/>
                  </CButton>


                </td>
              </template>
              <template #select-header="{item}">
                <input type="checkbox" v-model="check_all_exit"
                />
              </template>
              <template #select="{item}">
                <td>
                  <CCol>

                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                           :value="item.recId"/>

                  </CCol>

                </td>


              </template>
              <template #caption>
                <tr class="total-table">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>

                  <td>{{$t('totalCirculation')}}</td>

                  <td>
                    {{get_currency(calculate_items(items_sell,'totalPrice'))}}
                  </td>
                  <td></td>

                  <td></td>
                  <td></td>
                </tr>
              </template>
            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import PrintDocumentNew from "../documents/PrintDocumentNew.vue";

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    PrintDocumentNew
  },
  data() {
    return {
      route_items: [],
      selected_route: 0,
      messages_data_response: {},
      address_data_response: {},
      contact_data_response: {},
      print_selected_datas: [],
      print_selected_datas_products: [],
      fields_print_selected_products: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},
      ],
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      printed_doc_id: 0,
      name: '',
      check_all_exit: false,

      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,
      id_checkbox_items: [],
      item_sell_array: [],
      paid_type_items: [],

      selected_paid_type: 0,
      items_sell_filtered: [],
      items_sell: [],
      table_clicks_timer: '',
      table_clicks: 0,
      table_clicks_index: 0,

      fields: [
        {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:10%'},
        {key: 'partyCode', label: this.$t('customerCode'), _style: 'width:10%'},
        {key: 'partyName', label: this.$t('customerName'), _style: 'width:20%'},
        {key: 'createdBy', label: this.$t('docCreator'), _style: 'width:15%'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:15%'},

        {key: 'payType', label: this.$t('PaymentStatus'), _style: 'width:7%'},
        {key: 'lastStatus', label: this.$t('tables.status'), _style: 'width:7%'},

        // {key: 'operation', label: "", _style: 'width:3%', sorter: false, filter: false},
        // {key: 'select', label: "", _style: 'width:3%', sorter: false, filter: false},

      ],

      details: [],

      status_form: 0,
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },

    }
  },
  mounted() {
    if (!this.get_access("invoice_last_status")) {
      this.fields = this.fields.filter(x => x.key != 'lastStatus')
    }

    if(this.get_access('hyper_sale')){
      this.start_date = this.get_today();
    }else{
      this.start_date = this.get_day_before_today_in_day(6);
    }
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();
    this.get_sys();
    this.get_routes()

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on("delete_re_order_called", (data) => {
      this.get_all_data();
    });
  },
  watch: {
    '$route.params.person_id': function () {
      this.get_all_data();
    },
    // 'start_date': function () {
    //     this.get_all_data();
    // },
    // 'end_date': function () {
    //     this.get_all_data();
    // },
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.items_sell_filtered.forEach((val) => {
          // if (val.isReorder == null) {
            this.id_checkbox_items.push(val.recId);
          // }
        });
      } else {
        this.id_checkbox_items = [];
      }
    },
    'selected_paid_type': function () {
      if (this.selected_paid_type == 0) {
        this.items_sell_filtered = this.items_sell.filter(x => x.statusId == 1);

      } else {
        this.items_sell_filtered = this.items_sell.filter(x => x.statusId == 1 && parseInt(x.statusPayId) == this.selected_paid_type);
      }
    }

  },
  methods: {
    get_routes() {
      var self = this;

      const formData = new FormData();

      axios.post('GetRoutesNew', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.route_items = [{label: self.$t('all'), value: 0}]
          self.route_items = self.sort_array(self.route_items, content_data.data, 'id', 'title')
          self.selected_route = self.route_items[0].value;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_contact() {
      var self = this;

      const formData = new FormData();

      axios.post('GetContactById', formData, {}).then(function (response) {

        var content_data = response.data;
        self.contact_data_response = content_data
        self.get_main_address();
      }).catch(function (error) {
        console.log(error);
      });
    },

    get_main_address() {
      var self = this;

      const formData = new FormData();


      axios.post('GetAddressById', formData, {}).then(function (response) {

        self.address_data_response = response.data;
        self.get_messages()
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_messages() {
      var self = this;

      const formData = new FormData();

      formData.append('DocTypeId', 3);


      axios.post('message/GetData', formData, {}).then(function (response) {

        self.messages_data_response = response.data;

        // items = content_cats.orders;
        self.print_selected(false)


      })
          .catch(function (error) {
            console.log(error);
          });

    },


    print_selected(tajmi) {
      var self = this;

      const formData = new FormData();
      this.id_checkbox_items.forEach(function (val) {
        formData.append("factors[]", val)

      })
      axios.post('GetFactorFullInfoByIds', formData, {}).then(function (response) {

        var content_data = response.data;
        self.print_selected_datas = []
        self.print_selected_datas_products = []
        var find_index = -1
        self.print_selected_datas = content_data.data
        if (tajmi == true) {
          self.print_selected_datas.forEach(function (val) {
            val.factorDetailItems.forEach(function (item) {
              find_index = self.print_selected_datas_products.findIndex(x => x.productId == item.productId)
              console.log("finding tajmi", item, self.print_selected_datas_products, find_index)
              if (find_index == -1) {
                self.print_selected_datas_products.push(item)
              } else {
                self.print_selected_datas_products[find_index].qty = self.print_selected_datas_products[find_index].qty + item.qty

              }
            })

          })

        }
        setTimeout(function () {
          if (tajmi == false) {
            self.print_with_header_title_height_multiple_class('printMe_newprinter', 'print_report_header_new', 'print_report_footer_new', "Sale Report", 250, 320)

          } else {
            self.print_element('print_tajmi_factor_products', 'پرینت تجمیعی کالا ها')

          }
        }, 2000);

      }).catch(function (error) {

        console.log(error);
      });
    },

    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;

        self.paid_type_items = [];
        var obj = {label: self.$t('all'), value: 0}

        self.paid_type_items.push(obj);

        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 28) {
            self.paid_type_items.push(obj);
          }

        });


        self.selected_paid_type = self.paid_type_items[0].value


      }).catch(function (error) {

        console.log(error);
      });

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      this.table_clicks_index = index
      if (this.table_clicks == 1 && this.table_clicks_index == index) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.table_clicks = 0

        this.goShowDocument(item)

      }

    },
    get_all_data() {
      this.get_lists_sell();

    },

    get_lists_sell() {

      var self = this;
      var formData = new FormData();

      var url = "GetDocsByParams";
      formData.append("DocType", 3);
      if (self.$route.params.person_id != null) {
        formData.append("PersonId", self.$route.params.person_id);
      } else {
        if(this.has_permission('SaleReport')){
          formData.append("PersonId", 0);

        }else{
          formData.append("PersonId", localStorage.getItem('user_id'));

        }
      }

      // formData.append("id", 3);

      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);
      formData.append("RouteId", self.selected_route);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.items_sell = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          // self.items_sell.forEach(function (val) {
          //     val.totalPrice = parseFloat(val.totalPrice);
          // })
          self.items_sell_filtered = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_sell = self.items_sell.filter(x => x.statusId == 1)
          self.items_sell_filtered = self.items_sell.filter(x => x.statusId == 1)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },

    Finalize(item) {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorToFinal";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    send_to_customer(item) {
      var self = this;


      const formData = new FormData();

      var url = "SendFactorToTelegramBoth";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goReturnDocument(item) {
      this.$router.push({
        path: '/dashboard/documents/return/' + item.recId + "/false",
        params: {passed_data: "salam hamidddd"}
      });
    },
    goShowDocument(item) {
// if(item.isReorder==3){
      // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
// }else{
//                 this.$router.push({path: '/dashboard/documents/show/' + item.recId});
// }
      window.open('/dashboard/documents/show/' + item.recId)

    },
    goPrintDocument(item) {
      bus.$emit("print_confirm", item.recId);


    },
    AddRefer(item) {
      this.submit_refer = item.recId;
    },

    AddAllRefer() {
      this.submit_refer = -1;
      if (this.id_checkbox_items.length == 0) {
        console.log("validate form is false" + this.validate_errors);
        this.submit_refer = 0;

      }
    },

    AddReOrder() {
      if (this.id_checkbox_items.length > 0) {
        for (var i = 0; i < this.id_checkbox_items.length; i++) {
          if(this.items_sell_filtered.filter(x=>x.recId==this.id_checkbox_items[i])[0].isReorder==null){
            this.add_factor_to_reorder(this.id_checkbox_items[i]);
          }
        }
      }
    },

    add_factor_to_reorder(id) {
      let self = this;


      let url;
      // if (this.status_form == 0) {
      url = "AddReOrder";
      // }
      const formData = new FormData();

      formData.append('Id', id);

      axios.post(url, formData, {}).then((res) => {


        self.submit_refer = 0;
        if (self.id_checkbox_items[self.id_checkbox_items.length - 1] == id) {
          self.id_checkbox_items = [];
          self.$root.modal_component.show_api_response_modals(res);
          bus.$emit('reorder_added')
        }
        self.get_all_data();


      })
          .catch(function (error) {

            console.log(error);
          });
    },

    insert_refer() {
      let self = this;

      if (this.submit_refer != -1) {


        this.id_checkbox_items = [];
      } else {
        if (this.id_checkbox_items.length == 0) {
          console.log("validate form is false" + this.validate_errors);
          self.submit_refer = 0;
          self.id_checkbox_items = [];

          return true;
        }

      }
      if (this.refer_person == null) {
        console.log("validate form is false" + this.validate_errors);

        return true;
      }
      let url;
      // if (this.status_form == 0) {
      url = "AddFactorRefer";
      // }
      if (this.submit_refer != -1) {
        const formData = new FormData();

        formData.append('PersonId', this.refer_person);

        formData.append('MasterFactorId', this.submit_refer);
        axios.post(url, formData, {}).then((res) => {


          self.submit_refer = 0;
          self.id_checkbox_items = [];

          self.refer_person = null;

          self.$root.modal_component.show_api_response_modals(res);
          self.get_all_data()
        })
            .catch(function (error) {

              console.log(error);
            });
      } else {
        self.id_checkbox_items.forEach((val) => {

          const formData = new FormData();

          formData.append('PersonId', this.refer_person);

          formData.append('MasterFactorId', val);
          axios.post(url, formData, {}).then((res) => {


          })
              .catch(function (error) {

                console.log(error);
              });
        });
        self.id_checkbox_items = [];
        self.submit_refer = 0;
        self.id_checkbox_items = [];

        self.refer_person = null;

        this.get_all_data()
      }


    },

  },

}

</script>
